import { useBreakpoints, useRequest, useView } from '@10000/react'
import { InputScreen, subscriptionBackground, useBackground, useShell, useStack } from '../../layout'
import { Box } from '../../widgets'
import { Coupon, CreditCard } from '../../forms'
import { Industry } from '../account'
import { PasswordSetUp } from '../PasswordSetUp'

export const CardDetails = ({ active, fromFreeSquiz }) => {
  const request = useRequest('tenant')
  const { replaceStack } = useStack()
  const { mobile } = useBreakpoints()
  const { user: { passwordSet } } = useView('tenant')

  useShell({ active, mode: 'progress narrow', step: fromFreeSquiz ? 3 : 6, max: fromFreeSquiz ? 4 : 6 })
  useBackground().set(mobile => ({ active, fade: mobile, ...subscriptionBackground(mobile, true) }))

  const handleCardDetails = details => request('paymentMethodUpdated', details)
    .then(() => replaceStack(passwordSet ? Industry : PasswordSetUp, { props: { fromFreeSquiz } }))

  return <InputScreen fade onSubmit={handleCardDetails} title="Enter your card details" footerButton="Pay now">
    <Box gap={mobile ? 16 : 24} column>
      <CreditCard name="cardDetails"/>
      <Coupon name="promotion" />
    </Box>
  </InputScreen>
}